import { 
    LOGIN_SUCCESS, 
    LOGIN_FAILURE, 
    LOGOUT, 
    PASSWORD_RESET_REQUEST,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAILURE
} from '../action/auth';

const initialState = {
    user: null,
    error: null,
    loading: false,
    passwordReset: {
        loading: false,
        success: false,
        error: null
    }
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                user: action.payload,
                error: null,
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                user: null,
                error: action.payload,
            };
        case LOGOUT:
            return {
                ...state,
                user: null,
                error: null,
            };
        case PASSWORD_RESET_REQUEST:
            return {
                ...state,
                passwordReset: {
                    loading: true,
                    success: false,
                    error: null
                }
            };
        case PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                passwordReset: {
                    loading: false,
                    success: true,
                    error: null
                }
            };
        case PASSWORD_RESET_FAILURE:
            return {
                ...state,
                passwordReset: {
                    loading: false,
                    success: false,
                    error: action.payload
                }
            };
        default:
            return state;
    }
};

export default authReducer;
